import { findIntegrationByProviderInEntities } from '@vy/services';
import type { BaseIntegrationEntity } from '@vy/types';
import { INTEGRATION_PROVIDERS } from '@vy/types';
import { isNotNullOrUndefined, isNullOrUndefined } from '@vy/utils';

export function hasNetSuiteIntegration(integrationEntities: BaseIntegrationEntity[]| undefined): boolean {
  if (isNullOrUndefined(integrationEntities)) {
    return false;
  }

  const netSuiteEntity = findIntegrationByProviderInEntities(
    integrationEntities,
    INTEGRATION_PROVIDERS.netSuite
  );

  return isNotNullOrUndefined(netSuiteEntity);
}